var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',[_vm._t("left-action",null,{"goBack":_vm.goBack}),_c('div',[_vm._t("title")],2),_vm._t("right-action")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }